import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import jmpRatings from "../../../../src/data/articles/cube-prospective-jumpstart/jmp-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  jmpRatings,
  ProspectiveIntro,
  React
};